export const MEAL_TYPES = [
  {
    type: 1,
    label: "Breakfast",
    machineName: "BreakFast",
  },
  {
    type: 2,
    label: "Morning Snack",
    machineName: "MorningSnack",
  },
  {
    type: 3,
    label: "Morning Snack 2",
    machineName: "MorningSnack2",
  },
  {
    type: 4,
    label: "Lunch",
    machineName: "Lunch",
  },
  {
    type: 5,
    label: "Afternoon Snack",
    machineName: "AfternoonSnack",
  },
  {
    type: 6,
    label: "Dinner",
    machineName: "Dinner",
  },
  {
    type: 7,
    label: "Dinner Snack",
    machineName: "DinnerSnack",
  },
  {
    type: 8,
    label: "Pre Workout",
    machineName: "PreWorkoutMeal",
  },
  {
    type: 9,
    label: "Intra Workout",
    machineName: "IntraWorkoutMeal",
  },
  {
    type: 10,
    label: "Post Workout",
    machineName: "PostWorkoutMeal",
  },
  {
    type: 11,
    label: "Extras",
    machineName: "Extras",
  },
];
